import {
  GET_PRICING,
  GET_PRICING_TRIGGERS,
  GET_PRICING_TRIGGER_TYPES,
  CALCULATE_PRICING_RESPONSE,
} from "../actions/types";

export default (state = {}, action) => {
  let status = 200;
  let data = {};
  let notificationType = "info";
  if (
    action.payload != undefined &&
    typeof action.payload.status != "undefined"
  ) {
    status = action.payload.status;
    notificationType = "success";
    if (status >= 400) {
      notificationType = "error";
    }
    data = action.payload.data;
  }

  let response = {
    notificationType: notificationType,
    type: action.type,
    status: status,
    action: "LIST",
  };
  switch (action.type) {
    case GET_PRICING:
    case GET_PRICING_TRIGGERS:
    case GET_PRICING_TRIGGER_TYPES:
      response["data"] = data.data;
      break;
    case CALCULATE_PRICING_RESPONSE:
      response["data"] = data.data;
      response["action"] = "ACTION";
      break;
    default:
      return state;
  }
  return response;
};
